/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_PositioningInputs */



/**
* | output |
* | --- |
* | "Positioning" |
*
* @param {Metadata_Merge_PositioningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_positioning = /** @type {((inputs?: Metadata_Merge_PositioningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_PositioningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Positionnement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Positionierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizionamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиционирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posicionamiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("定位")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posicionamento")
	return /** @type {LocalizedString} */ ("Positioning")
});